import { useQuery } from 'react-query';

import usePageContext from '@/hooks/usePageContext';
import * as Repo from './serviceProviders.repo';
import * as Types from './serviceProviders.types';

export const useServiceProvider = ({ providerId, locationId }: Types.GetServiceProviderRequest) =>
  useQuery(['getServiceProvider', providerId, locationId], () => Repo.getServiceProvider({ providerId, locationId }));

export const useServiceProviders = (locationId) => {
  const { companyOverview } = usePageContext();

  return useQuery(
    ['getServiceProviders', locationId, companyOverview?.id],
    () => Repo.getServiceProviders(locationId, companyOverview?.id),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!locationId && !!companyOverview?.id,
    },
  );
};

export const useAvailableDays = ({
  startDate,
  endDate,
  localId,
  services,
  providers,
  providersArray,
  bundled,
  bundleId,
  ...options
}) =>
  useQuery(
    ['availableDays', startDate, endDate, localId, services, providers, providersArray, bundled, bundleId],
    () =>
      Repo.getAvailableDays({
        startDate,
        endDate,
        localId,
        services,
        providers,
        providersArray,
        bundled,
        bundleId,
      }),
    {
      ...options,
      enabled: !!startDate && !!endDate,
      cacheTime: 0,
      staleTime: 0,
    },
  );

export const useAvailableHours = ({
  startDate,
  endDate,
  localId,
  services,
  providers,
  providersArray,
  datesAndProviders,
  bundled,
  bundleId,
  ...options
}) =>
  useQuery(
    [
      'availableHours',
      startDate,
      endDate,
      localId,
      services,
      providers,
      providersArray,
      datesAndProviders,
      bundled,
      bundleId,
    ],
    () =>
      Repo.getAvailableHours({
        startDate,
        endDate,
        localId,
        services,
        providers,
        providersArray,
        datesAndProviders,
        bundled,
        bundleId,
      }),
    {
      ...options,
      enabled: !!startDate,
      refetchOnWindowFocus: true,
      refetchInterval: 30000,
    },
  );

export const useNextAvailableDay = ({
  startDate,
  endDate,
  localId,
  services,
  providers,
  providersArray,
  datesAndProviders,
  bundled,
  bundleId,
  ...options
}) =>
  useQuery(
    ['nextAvailableDay', startDate, endDate, localId, services, providers, bundled, bundleId, datesAndProviders],
    () =>
      Repo.getNextAvailableDay({
        bundled,
        bundleId,
        datesAndProviders,
        endDate,
        localId,
        providers,
        providersArray,
        services,
        startDate,
      }),
    {
      ...options,
    },
  );
